export enum CounselingMemoUploadType {
  REGISTER = "REGISTER",
  UPDATE = "UPDATE",
}

export enum RegistrationStatus {
  PRE_REGISTERED = '仮登録',
  REGISTERED = '本登録',
  DECIDED = '決定',
  SERVICE_ENDED = 'サービス終了',
  DISCONTINUITY = '音信不通',
  STOPPED_INTRODUCING = '紹介停止',
  DELETED_PERSONAL_INFO = '個人情報削除',
}

export enum StudentAIInterviewType {
  GPS = 0,
  PEOPLEX = 1,
}
